import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import Layout from "@/components/Layout";
import { EventContentProvider } from "@/context/EventContentContext";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Program from "@/pages/Program";
import Chefs from "@/pages/Chefs";
import Menu from "@/pages/Menu";
import Location from "@/pages/Location";
import Announcements from "@/pages/Announcements";
import Gallery from "@/pages/Gallery";
import FAQ from "@/pages/FAQ";
import StaffGate from "@/pages/StaffGate";
import StaffPortal from "@/pages/StaffPortal";
import AdminPanel from "@/pages/AdminPanel";
import Tickets from "@/pages/Tickets";
import TicketResult from "@/pages/TicketResult";
import MyAccount from "@/pages/MyAccount";

function StaffRoute() {
  const [unlocked, setUnlocked] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("cg_staff") === "1") setUnlocked(true);
  }, []);

  const logout = () => {
    sessionStorage.removeItem("cg_staff");
    sessionStorage.removeItem("cg_staff_pin");
    setUnlocked(false);
  };

  return unlocked ? (
    <StaffPortal onLogout={logout} />
  ) : (
    <StaffGate onUnlock={() => setUnlocked(true)} />
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <EventContentProvider>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/evento" element={<About />} />
              <Route path="/programa" element={<Program />} />
              <Route path="/chefs" element={<Chefs />} />
              <Route path="/menu" element={<Menu />} />
              <Route path="/ubicacion" element={<Location />} />
              <Route path="/anuncios" element={<Announcements />} />
              <Route path="/galeria" element={<Gallery />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/boletos" element={<Tickets />} />
              <Route path="/boletos/resultado" element={<TicketResult />} />
              <Route path="/mi-cuenta" element={<MyAccount />} />
              <Route path="/staff" element={<StaffRoute />} />
              <Route path="/admin" element={<AdminPanel />} />
            </Routes>
          </Layout>
        </EventContentProvider>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
